import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "z-10 text-2xs"
};
const _hoisted_2 = {
  key: 0,
  class: "absolute icon-refresh text-sm -top-1 -right-1 text-second-100"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FloatingElement = _resolveComponent("FloatingElement");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative group relative flex items-center justify-center aspect-square cursor-pointer transition-[background]", [{
      'text-main-5! font-medium': this.state.selected
    }, {
      'text-main-50': this.adjacent
    }]]),
    onMouseenter: _cache[2] || (_cache[2] = $event => this.mouseOverDay = true),
    onMouseleave: _cache[3] || (_cache[3] = $event => this.Delay(() => this.mouseOverDay = false))
  }, [_createElementVNode("p", _hoisted_1, _toDisplayString(this.day), 1), this.state.between ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["absolute inset-y-[12%] inset-x-0 bg-second-10 transition-[background,inset,border-radius]", [{
      'left-1/2 w-1/2!': this.state.start
    }, {
      'right-1/2 w-1/2!': this.state.end
    }, {
      'group-hover:inset-[8%] group-hover:rounded': !this.state.selected
    }]])
  }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["absolute inset-[8%] rounded group-hover:bg-second-10 transition-colors", [{
      'bg-second-100!': this.state.selected
    }, {
      'border border-second-10': this.state.today && !this.state.between
    }, {
      'bg-second-10/50': this.state.interval
    }]])
  }, [this.state.interval ? (_openBlock(), _createElementBlock("i", _hoisted_2)) : _createCommentVNode("", true)], 2), this.events?.length ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["absolute top-2 right-2 rounded-full bg-second-100 p-0.5 animate-pulse", {
      'bg-cta2-100!': this.state.selected
    }])
  }, null, 2)) : _createCommentVNode("", true), this.events?.length && (this.mouseOverDay || this.mouseOverEvent) ? (_openBlock(), _createBlock(_component_FloatingElement, {
    key: 2,
    position: {
      top: 0,
      right: -2,
      translateX: true,
      centerY: true
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "max-h-[300px] max-w-[260px] flex flex-col gap-1 p-1 rounded bg-white shadow-material overflow-y-auto scroll scroll-main",
      onMouseenter: _cache[0] || (_cache[0] = $event => this.mouseOverEvent = true),
      onMouseleave: _cache[1] || (_cache[1] = $event => this.mouseOverEvent = false)
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.events, event => {
      return _openBlock(), _createElementBlock("div", {
        key: event,
        class: "flex flex-col gap-0.5 py-1 px-2 rounded hover:bg-main-5 border border-main-5 cursor-pointer overflow-hidden shrink-0",
        onClick: $event => this.$openExternal(event.href)
      }, [_createElementVNode("div", {
        class: _normalizeClass(["text-xs", {
          'text-main-50': !event.summary
        }])
      }, _toDisplayString(event.summary ?? 'Title'), 3), _createElementVNode("div", {
        class: _normalizeClass(["text-main-75 text-2xs", {
          'text-main-50': !event.description
        }]),
        innerHTML: event.description ?? 'Description'
      }, null, 10, _hoisted_4)], 8, _hoisted_3);
    }), 128))], 32)]),
    _: 1
  })) : _createCommentVNode("", true)], 34);
}